import React from 'react';
import './styles/MyAccount.css';
import i18next from 'i18next';

/**
 * Placeholder per le sottopagine di Il Mio Conto (Dati Personali, Lista Scommesse, ecc.).
 * Da sostituire con componenti reali quando pronti.
 */
function MyAccountPlaceholder({ title, children }) {
  return (
    <div className="my-account-placeholder">
      <h1 className="my-account-panel-title">{title}</h1>
      <div className="my-account-placeholder-body">
        {children || (
          <p className="light-grey">
            {i18next.t('Questa sezione non è ancora stata costruita. Le altre pagine sono nel menu in alto.')}
          </p>
        )}
      </div>
    </div>
  );
}

export default MyAccountPlaceholder;
